import { Box, Modal, Typography, Divider, Link, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface WhereModalProps {
  isOpen: boolean;
  handleClose: () => void;
}

const outerStyle = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: { xs: 2, sm: 4 },
  borderRadius: 2,
  width: { xs: "87vw", sm: "80vw" },
  maxWidth: 600,
  maxHeight: "75vh",
  display: "flex",
  flexDirection: "column",
  overflow: "visible", 
};

const contentStyle = {
  overflowY: "auto",        
  flex: "1 1 auto",         
  minHeight: 0,
  pr: 0,
  pl: 0,
};


const WhereModal = ({ isOpen, handleClose }: WhereModalProps) => {
  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="where-modal-title"
      aria-describedby="where-modal-description"
    >
      <Box sx={outerStyle}>
        <IconButton
          onClick={handleClose}
          aria-label="close"
          sx={{
            position: "absolute",
            top: 12,
            right: 12,
            color: "text.secondary",
            backgroundColor: "rgba(255,255,255,0.85)",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,1)",
            },
            zIndex: 10,
          }}
        >
          <CloseIcon />
        </IconButton>

        <Typography
          id="where-modal-title"
          variant="h4"
          fontWeight="bold"
          gutterBottom
          sx={{ pr: 6 }}
        >
          Dalmeny Park House Hotel
        </Typography>
          
        <Box sx={contentStyle}>
          <Typography variant="body1" paragraph>
            <strong>Dalmeny Park House Hotel</strong> is a stunning country house venue nestled
            in the "peaceful" town of <strong>Barrhead</strong>, on the outskirts of
            <strong> Glasgow</strong>. Surrounded by landscaped gardens and elegant interiors,
            it provides a romantic and memorable setting for our celebration.
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="h6" gutterBottom>
            🏨 Accommodation
          </Typography>
          <Typography variant="body1" paragraph>
            Dalmeny Park House Hotel will host our wedding day. While the venue offers a small
            number of rooms, <strong>on-site accommodation is reserved
            for the wedding party and close family</strong>.
          </Typography>
          <Typography variant="body1" paragraph>
            We kindly ask all other guests to arrange nearby accommodation. There are several
            excellent options within 10–15 minutes of the venue, including:
          </Typography>
          <ul>
            <li><Typography variant="body1"><Link href="https://www.premierinn.com/gb/en/hotels/scotland/strathclyde/glasgow/glasgow-newton-mearns-m77-j4.html" target="_blank" rel="noopener noreferrer" underline="hover">Premier Inn Newton Mearns</Link></Typography></li>
            <li><Typography variant="body1"><Link href="https://www.premierinn.com/gb/en/hotels/scotland/strathclyde/glasgow/glasgow-paisley.html" target="_blank" rel="noopener noreferrer" underline="hover">Premier Inn Paisley</Link></Typography></li>
            <li><Typography variant="body1" ><Link href="https://www.parklandshotel.co.uk/" target="_blank" rel="noopener noreferrer" underline="hover">Parklands Hotel & Country Club</Link></Typography></li>
            <li><Typography variant="body1"><Link href="https://www.google.com/maps/place/Travelodge+Glasgow+Paisley+Road/@55.7978842,-4.4341811,11.87z/data=!4m17!1m5!2m4!1sTravelodge!5m2!5m1!1s2026-03-22!3m10!1s0x48884686805daf27:0xcf2f5c7d15ec5334!5m3!1s2026-03-22!4m1!1i2!8m2!3d55.8528765!4d-4.2724686!15sCgpUcmF2ZWxvZGdlIgOIAQFaDCIKdHJhdmVsb2RnZZIBBWhvdGVs4AEA!16s%2Fg%2F1w96g9w_?entry=ttu&g_ep=EgoyMDI2MDEyMS4wIKXMDSoKLDEwMDc5MjA2OUgBUAM%3D" target="_blank" rel="noopener noreferrer" underline="hover">Travelodge Glasgow</Link></Typography></li>
            <li><Typography variant="body1"><Link href="https://www.booking.com/hotel/gb/the-abbey-inn.en-gb.html" target="_blank" rel="noopener noreferrer" underline="hover">The Abbey Inn</Link></Typography></li>
          </ul>

          <Divider sx={{ my: 2 }} />

          <Typography variant="h6" gutterBottom>
            🚗 Travel & Directions
          </Typography>
          <Typography variant="body1" paragraph>
            Dalmeny Park House Hotel is located at:
            <br />
            <Link
              href="https://www.google.com/maps/place/Dalmeny+Park+House+Hotel/"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
            >
              Lochlibo Road, Barrhead, Glasgow G78 1LG
            </Link>
          </Typography>

          <Typography variant="body1" paragraph>
            The venue is approximately <strong>20 minutes by car</strong> from Glasgow city centre
            and around <strong>15 minutes from Glasgow Airport</strong>. Taxi
            services operate in the area. Barrhead also has a train station
            with direct routes to Glasgow Central Station.
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="body2" color="text.secondary" align="center" sx={{ pb: 1 }}>
            We can’t wait to celebrate with you!
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};

export default WhereModal;
